<template>
  <div class="heroes-list">
    <div class="heroes-list__header">
      <div class="heroes-list__title">Выбор героев</div>
      <div class="heroes-list__search">
        <div class="heroes-list__search-label">Найти героя:</div>
        <input
          type="text"
          class="heroes-list__input"
          placeholder="Введите героя"
          v-model="search"
        />
      </div>
    </div>

    <div class="heroes-list__categories">
      <HeroesListCategory
        v-for="category in categories"
        :key="category.id"
        :category="category"
        :checked="category.id === category_id"
        @click="category_id = category.id"
      />
    </div>

    <div v-if="heroes" class="heroes-list__list-wrapper">
      <p class="heroes-list__message" v-if="!filteredHeroes.length">
        Герои не найдены
      </p>
      <div v-else class="heroes-list__list">
        <div
          v-for="hero in filteredHeroes"
          :key="hero.id"
          class="heroes-list__col"
        >
          <HeroesListHero
            :hero="hero"
            :access="isPicker"
            @select="selectHero"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import HeroesListCategory from "./HeroesListCategory";
import HeroesListHero from "./HeroesListHero";
import { openPickHeroModal } from "./PickHero";

export default {
  name: "HeroesList",

  components: {
    HeroesListCategory,
    HeroesListHero
  },

  data: () => ({
    category_id: 2,
    search: "",
    categories: [
      {
        id: 1,
        name: "Сила",
        img: require("@/assets/img/heroes/category-strength.png")
      },
      {
        id: 2,
        name: "Ловкость",
        img: require("@/assets/img/heroes/category-agility.png")
      },
      {
        id: 3,
        name: "Интелект",
        img: require("@/assets/img/heroes/category-intellect.png")
      }
    ]
  }),

  computed: {
    ...mapGetters("tournaments", ["picker", "pickInfo", "match"]),
    ...mapGetters("auth", ["user"]),
    ...mapState("dictionaries", {
      heroes: ({ dictionaries }) => dictionaries.heroes
    }),
    isPicker() {
      const { picker, user } = this;
      return picker && user && picker.id === user.id;
    },
    herouesByAttribute() {
      return this.heroes.filter(hero => hero.attribute === this.category_id);
    },
    filteredHeroes() {
      try {
        const re = new RegExp(this.search, "i");
        return this.herouesByAttribute.filter(hero => ~hero.name.search(re));
      } catch {
        return [];
      }
    }
  },

  methods: {
    selectHero(hero) {
      if (!this.isPicker) return;
      openPickHeroModal({ hero, action: this.pickInfo.action });
    }
  }
};
</script>

<style lang="scss">
.heroes-list {
  color: #fff;
  border: 2px solid #414a65;
  padding: 25px 20px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
  }

  &__title {
    font-weight: 900;
    font-size: 22px;
    font-family: "Montserrat";
    line-height: 27px;
  }

  &__search-label {
    font-size: 14px;
    white-space: nowrap;
  }

  &__categories {
    display: flex;
  }

  &__list-wrapper {
    border-radius: 10px;
    background-color: #0f1a39;
    padding: 30px 15px 15px;
  }

  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: -5px;
  }

  &__col {
    padding: 5px;
  }

  &__message {
    text-align: center;
    font-size: 18px !important;
    margin-bottom: 15px !important;
  }

  &__search {
    display: flex;
    align-items: center;
  }

  &__input {
    height: 30px;
    width: 154px;
    border-radius: 25px;
    background-color: #000a25;
    font-size: 12px;
    font-weight: 300;
    color: #fff;
    margin-left: 10px;
    padding: 3px 10px;
    text-align: center;
    font-style: italic;
    @include placeholder() {
      color: rgba(#fff, 0.5);
    }
    &:focus {
      outline: none;
      box-shadow: 0 0 0 1px #1480b2;
    }
  }

  @include breakpoint("sm-and-down") {
    padding: 20px 15px;
    &__list {
      justify-content: center;
    }
    &__title {
      margin-bottom: 15px;
    }
    &__header {
      flex-direction: column;
    }
  }

  @include breakpoint("xs-only") {
    &__search {
      width: 100%;
    }
    &__input {
      width: 130px;
      margin-left: auto;
    }
  }
}
</style>
